export const WOULD_ENROLL = 'WOULD_ENROLL';
export const WOULD_NOT_ENROLL_NO_STARTING_LIST = 'WOULD_NOT_ENROLL_NO_STARTING_LIST';
export const WOULD_NOT_ENROLL_NOT_IN_STARTING_LIST = 'WOULD_NOT_ENROLL_NOT_IN_STARTING_LIST';
export const WOULD_NOT_ENROLL_IN_SUPPRESSION_LIST = 'WOULD_NOT_ENROLL_IN_SUPPRESSION_LIST';
export const WOULD_NOT_ENROLL_IN_GOAL_LIST = 'WOULD_NOT_ENROLL_IN_GOAL_LIST';
export const WOULD_NOT_ENROLL_CURRENTLY_ENROLLED = 'WOULD_NOT_ENROLL_CURRENTLY_ENROLLED';
export const WOULD_NOT_ENROLL_ALREADY_FINISHED_AN_ENROLLMENT = 'WOULD_NOT_ENROLL_ALREADY_FINISHED_AN_ENROLLMENT';
export const WOULD_NOT_ENROLL_INVALID_ANCHOR_PROPERTY_VALUE = 'WOULD_NOT_ENROLL_INVALID_ANCHOR_PROPERTY_VALUE';
export const UNKNOWN_TRY_AGAIN = 'UNKNOWN_TRY_AGAIN';
export const WOULD_NOT_ENROLL_NOT_IN_REFINE_BY_LIST = 'WOULD_NOT_ENROLL_NOT_IN_REFINE_BY_LIST';